import {
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  Switch,
} from "@mui/material";
import { doc, updateDoc } from "firebase/firestore";
import React, { useEffect } from "react";
import { db } from "../firebaseConfig";
import { toast } from "react-toastify";

function CommonRestrictionTable({ customIqs,data:itemData }) {
  console.log(customIqs,itemData,"customIq in common");
  
  const data = (customIq) => ([
    {
      category: "General Compliance",
      system: { disabled: false },
      human: { disabled: false },
      child: [
        {
          category: "Dangerous Goods",
          id: "dangerousGoods",
          system: {
            disabled: true,
            checked: customIq?.dangerousGoods?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.dangerousGoods?.humanValidation,
          },
        },
        {
          category: "Restricted",
          id: "restricted",
          system: {
            disabled: true,
            checked: customIq?.restricted?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.restricted?.humanValidation,
          },
        },
        {
          category: "Prohibited",
          id: "prohibited",
          system: {
            disabled: true,
            checked: customIq?.prohibited?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.prohibited?.humanValidation,
          },
        },
      ],
    },
    {
      category: "Licensing and Documentation",
      system: { disabled: false },
      human: { disabled: false },
      child: [
        {
          category: "Licence is required",
          id: "licenseRequired",
          system: {
            disabled: true,
            checked: customIq?.licenseRequired?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.licenseRequired?.humanValidation,
          },
        },
        {
          category: "Prescription is required",
          id: "prescriptionRequired",
          system: {
            disabled: true,
            checked: customIq?.prescriptionRequired?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.prescriptionRequired?.humanValidation,
          },
        },
      ],
    },
    {
      category: "Legal Concerns",
      system: { disabled: false },
      human: { disabled: false },
      child: [
        {
          category: "Counterfeit or replica",
          id: "counterfeitOrReplica",
          system: {
            disabled: true,
            checked: customIq?.counterfeitOrReplica?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.counterfeitOrReplica?.humanValidation,
          },
        },
        {
          category: "Bullion of any kind",
          id: "bullionOfAnyKind",
          system: {
            disabled: true,
            checked: customIq?.bullionOfAnyKind?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.bullionOfAnyKind?.humanValidation,
          },
        },
        {
          category: "Illicit drug",
          id: "illicitDrug",
          system: {
            disabled: true,
            checked: customIq?.illicitDrug?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.illicitDrug?.humanValidation,
          },
        },
      ],
    },
    {
      category: "Safety and Security",
      system: { disabled: false },
      human: { disabled: false },
      child: [
        {
          category: "Explosives",
          id: "explosives",
          system: {
            disabled: true,
            checked: customIq?.explosives?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.explosives?.humanValidation,
          },
        },
        {
          category: "Gun and gun accessories",
          id: "gunAndGunAccessories",
          system: {
            disabled: true,
            checked: customIq?.gunAndGunAccessories?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.gunAndGunAccessories?.humanValidation,
          },
        },
      ],
    },
  ]);
  const data2 = (customIq) => ([
    {
      category: "organic and Perishable items",
      system: { disabled: false },
      human: { disabled: false },
      child: [
        {
          category: "Animal or Animal extract",
          id: "animalOrAnimalExtract",
          system: {
            disabled: true,
            checked: customIq?.animalOrAnimalExtract?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.animalOrAnimalExtract?.humanValidation,
          },
        },
        {
          category: "Perishable food",
          id: "perishableFood",
          system: {
            disabled: true,
            checked: customIq?.perishableFood?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.perishableFood?.humanValidation,
          },
        },
        {
          category: "Seeds or live plants",
          id: "seedsOrLivePlants",
          system: {
            disabled: true,
            checked: customIq?.seedsOrLivePlants?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.seedsOrLivePlants?.humanValidation,
          },
        },
        {
          category: "Frozen",
          id: "frozen",
          system: {
            disabled: true,
            checked: customIq?.frozen?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.frozen?.humanValidation,
          },
        },
        {
          category: "If Fresh",
          id: "ifFresh",
          system: {
            disabled: true,
            checked: customIq?.ifFresh?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.ifFresh?.humanValidation,
          },
        },
        {
          category: "Processed food",
          id: "processedFood",
          system: {
            disabled: true,
            checked: customIq?.processedFood?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.processedFood?.humanValidation,
          },
        },
      ],
    },
    {
      category: "Cultural and Sensitive Items",
      system: { disabled: false },
      human: { disabled: false },
      child: [
        {
          category: "Religious items or objects",
          id: "religiousItemsOrObjects",
          system: {
            disabled: true,
            checked: customIq?.religiousItemsOrObjects?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.religiousItemsOrObjects?.humanValidation,
          },
        },
        {
          category: "Non-muslim Religious item",
          id: "nonMuslimReligiousItem",
          system: {
            disabled: true,
            checked: customIq?.nonMuslimReligiousItem?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.nonMuslimReligiousItem?.humanValidation,
          },
        },
        {
          category: "Pornography",
          id: "pornography",
          system: {
            disabled: true,
            checked: customIq?.pornography?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.pornography?.humanValidation,
          },
        },
        {
          category: "Sex Toys or objects",
          id: "sexToysOrObjects",
          system: {
            disabled: true,
            checked: customIq?.sexToysOrObjects?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.sexToysOrObjects?.humanValidation,
          },
        },
      ],
    },
    {
      category: "Special Categories",
      system: { disabled: false },
      human: { disabled: false },
      child: [
        {
          category: "Endangered species",
          id: "endangeredSpecies",
          system: {
            disabled: true,
            checked: customIq?.endangeredSpecies?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.endangeredSpecies?.humanValidation,
          },
        },
        {
          category: "High Fashion",
          id: "highFashion",
          system: {
            disabled: true,
            checked: customIq?.highFashion?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.highFashion?.humanValidation,
          },
        },
        {
          category: "Supplements",
          id: "supplements",
          system: {
            disabled: true,
            checked: customIq?.supplements?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.supplements?.humanValidation,
          },
        },
      ],
    },
  ]);
  const data3 = (customIq) => ([
    {
      category: "Substance Controls",
      system: { disabled: false },
      human: { disabled: false },
      child: [
        {
          category: "Tobacco products",
          id: "tobaccoProducts",
          system: {
            disabled: true,
            checked: customIq?.tobaccoProducts?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.tobaccoProducts?.humanValidation,
          },
        },
        {
          category: "CBD or THC",
          id: "cbdOrThc",
          system: {
            disabled: true,
            checked: customIq?.cbdOrThc?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.cbdOrThc?.humanValidation,
          },
        },
        {
          category: "Vaping device",
          id: "vippingDevice",
          system: {
            disabled: true,
            checked: customIq?.vippingDevice?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.vippingDevice?.humanValidation,
          },
        },
        {
          category: "Hookah or water pipes",
          id: "hookahOrWaterPipes",
          system: {
            disabled: true,
            checked: customIq?.hookahOrWaterPipes?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.hookahOrWaterPipes?.humanValidation,
          },
        },
      ],
    },
  ]);

  const data4 = (customIq) => ([
    {
      category: "Battery Safety",
      system: { disabled: false },
      human: { disabled: false },
      child: [
        {
          category: "Standalone batteries",
          id: "standaloneBatteries",
          system: {
            disabled: true,
            checked: customIq?.standaloneBatteries?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.standaloneBatteries?.humanValidation,
          },
        },
        {
          category: "Lithium-ion battery",
          id: "lithiumIonBattery",
          system: {
            disabled: true,
            checked: customIq?.lithiumIonBattery?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.lithiumIonBattery?.humanValidation,
          },
        },
        {
          category: "Additional battery",
          id: "additionalBattery",
          system: {
            disabled: true,
            checked: customIq?.additionalBattery?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.additionalBattery?.humanValidation,
          },
        },
        {
          category: "External battery",
          id: "externalBattery",
          system: {
            disabled: true,
            checked: customIq?.externalBattery?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.externalBattery?.humanValidation,
          },
        },
      ],
    },
    {
      category: "Flammable and Hazardous Materials",
      system: { disabled: false },
      human: { disabled: false },
      child: [
        {
          category: "Flammable",
          id: "flammable",
          system: {
            disabled: true,
            checked: customIq?.flammable?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.flammable?.humanValidation,
          },
        },
        {
          category: "Alcohol",
          id: "alcohol",
          system: {
            disabled: true,
            checked: customIq?.alcohol?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.alcohol?.humanValidation,
          },
        },
        {
          category: "Perfume and colognes",
          id: "perfumeAndColognes",
          system: {
            disabled: true,
            checked: customIq?.perfumeAndColognes?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.perfumeAndColognes?.humanValidation,
          },
        },
        {
          category: "Engine parts",
          id: "engineParts",
          system: {
            disabled: true,
            checked: customIq?.engineParts?.customIqResponse,
          },
          human: {
            disabled: false,
            checked: customIq?.engineParts?.humanValidation,
          },
        },
      ],
    },
  ]);
  console.log(data,"data in common");
  
  const [restrictions, setRestrictions] = React.useState([]);
  const [restrictions2, setRestrictions2] = React.useState([]);
  const [restrictions3, setRestrictions3] = React.useState([]);
  const [restrictions4, setRestrictions4] = React.useState([]);

  useEffect(()=>{
    console.log(data(customIqs),"bnnhjyu");
    
    setRestrictions(data(customIqs));
    setRestrictions2(data2(customIqs));
    setRestrictions3(data3(customIqs));
    setRestrictions4(data4(customIqs));
  },[customIqs])


  return (
    <>
      <Box sx={{ marginTop: "20px", marginBottom: "10px" }}>
        <label
          style={{
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Regular and legal Restriction
        </label>
      </Box>
      {restrictions.map((parentCategory, parentIndex) => (
        <React.Fragment key={parentIndex}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#F9FAFC",
              height: "38px",
              border: "1px solid #E5E5E8",
              paddingX: "20px",
              paddingY: "10px",
            }}
          >
            <Box sx={{ width: "50%" }}>
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                {parentCategory.category}
              </label>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "25%",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                System
              </label>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "25%",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                Human
              </label>
            </Box>
          </Box>
          {parentCategory.child.map((childCategory, childIndex) => (
            <Box
              key={childIndex}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                height: "44px",
                border: "1px solid #E5E5E8",
                borderTop: "none",
                paddingX: "20px",
                paddingY: "10px",
              }}
            >
              <Box sx={{ width: "50%" }}>
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {childCategory.category}
                </label>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25%",
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    disabled={childCategory.system.disabled}
                    control={
                      <Switch defaultChecked={childCategory.system.checked} />
                    }
                  />
                </FormGroup>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25%",
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    disabled={childCategory.human.disabled}
                    name={childCategory.category}
                    control={
                      <Switch
                        checked={childCategory.human.checked}
                        onChange={(e) => {
                          const updatedData = [...restrictions];
                          updatedData[parentIndex].child[
                            childIndex
                          ].human.checked = e.target.checked;
                          setRestrictions(updatedData);
                        }}
                      />
                    }
                  />
                </FormGroup>
              </Box>
            </Box>
          ))}
        </React.Fragment>
      ))}
      <Box
        className="mt-2"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={async () => {
            const updatedCustomIqs = {};
            restrictions?.map((restriction) => {
              restriction?.child?.map((child) => {
                updatedCustomIqs[child.id] = {
                  customIqResponse: child.system.checked,
                  humanValidation: child.human.checked,
                };
              });
            });
            console.log(
              itemData?.itemId,
              customIqs, updatedCustomIqs,
              "updatedCustomIqs"
            );
            const updated = { ...customIqs, ...updatedCustomIqs };
            const docRef = doc(db, "items", itemData?.itemId);
            updateDoc(docRef, {
              customiqRestrictions: updated,
            }).then((res) => {
              console.log(res,"resp in update doc");
              toast.success("Custom Iq restrictions updated successfully");
            });
          }}
        >
          Submit
        </Button>
      </Box>
      <Box sx={{ marginTop: "20px", marginBottom: "10px" }}>
        <label
          style={{
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Nature of Goods
        </label>
      </Box>
      {restrictions2.map((parentCategory, parentIndex) => (
        <React.Fragment key={parentIndex}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#F9FAFC",
              height: "38px",
              border: "1px solid #E5E5E8",
              paddingX: "20px",
              paddingY: "10px",
            }}
          >
            <Box sx={{ width: "50%" }}>
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                {parentCategory.category}
              </label>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "25%",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                System
              </label>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "25%",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                Human
              </label>
            </Box>
          </Box>
          {parentCategory.child.map((childCategory, childIndex) => (
            <Box
              key={childIndex}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                height: "44px",
                border: "1px solid #E5E5E8",
                borderTop: "none",
                paddingX: "20px",
                paddingY: "10px",
              }}
            >
              <Box sx={{ width: "50%" }}>
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {childCategory.category}
                </label>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25%",
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    disabled={childCategory.system.disabled}
                    control={
                      <Switch defaultChecked={childCategory.system.checked} />
                    }
                  />
                </FormGroup>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25%",
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    disabled={childCategory.human.disabled}
                    control={
                      <Switch
                        checked={childCategory.human.checked}
                        onChange={(e) => {
                          const updatedData = [...restrictions2];
                          updatedData[parentIndex].child[
                            childIndex
                          ].human.checked = e.target.checked;
                          console.log(updatedData, "updateData data");
                          setRestrictions2(updatedData);
                        }}
                      />
                    }
                  />
                </FormGroup>
              </Box>
            </Box>
          ))}
        </React.Fragment>
      ))}
      <Box
        className="mt-2"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={async () => {
            const updatedCustomIqs = {};
            restrictions2?.map((restriction) => {
              restriction?.child?.map((child) => {
                updatedCustomIqs[child.id] = {
                  customIqResponse: child.system.checked,
                  humanValidation: child.human.checked,
                };
              });
            });
            const updated = { ...customIqs, ...updatedCustomIqs };
            console.log(updated, updatedCustomIqs, "updated jhi");
            const docRef = doc(db, "items", itemData?.itemId);
            await updateDoc(docRef, {
              customiqRestrictions: updated,
            });
          }}
        >
          Submit
        </Button>
      </Box>
      <Box sx={{ marginTop: "20px", marginBottom: "10px" }}>
        <label
          style={{
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Specific product Regulations
        </label>
      </Box>
      {restrictions3.map((parentCategory, parentIndex) => (
        <React.Fragment key={parentIndex}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#F9FAFC",
              height: "38px",
              border: "1px solid #E5E5E8",
              paddingX: "20px",
              paddingY: "10px",
            }}
          >
            <Box sx={{ width: "50%" }}>
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                {parentCategory.category}
              </label>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "25%",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                System
              </label>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "25%",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                Human
              </label>
            </Box>
          </Box>
          {parentCategory.child.map((childCategory, childIndex) => (
            <Box
              key={childIndex}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                height: "44px",
                border: "1px solid #E5E5E8",
                borderTop: "none",
                paddingX: "20px",
                paddingY: "10px",
              }}
            >
              <Box sx={{ width: "50%" }}>
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {childCategory.category}
                </label>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25%",
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    disabled={childCategory.system.disabled}
                    control={
                      <Switch defaultChecked={childCategory.system.checked} />
                    }
                  />
                </FormGroup>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25%",
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    disabled={childCategory.human.disabled}
                    control={
                      <Switch
                        checked={childCategory.human.checked}
                        onChange={(e) => {
                          const updatedData = [...restrictions3];
                          updatedData[parentIndex].child[
                            childIndex
                          ].human.checked = e.target.checked;
                          console.log(updatedData, "updateData data");
                          setRestrictions3(updatedData);
                        }}
                      />
                    }
                  />
                </FormGroup>
              </Box>
            </Box>
          ))}
        </React.Fragment>
      ))}
      <Box
        className="mt-2"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={async () => {
            const updatedCustomIqs = {};
            restrictions3?.map((restriction) => {
              restriction?.child?.map((child) => {
                updatedCustomIqs[child.id] = {
                  customIqResponse: child.system.checked,
                  humanValidation: child.human.checked,
                };
              });
            });
            const updated = { ...customIqs, ...updatedCustomIqs };
            console.log(updated, updatedCustomIqs, "updated jhi");
            const docRef = doc(db, "items", itemData?.itemId);
            await updateDoc(docRef, {
              customiqRestrictions: updated,
            });
          }}
        >
          Submit
        </Button>
      </Box>
      <Box sx={{ marginTop: "20px", marginBottom: "10px" }}>
        <label
          style={{
            fontWeight: "bold",
            fontSize: "16px",
          }}
        >
          Bettary and Chemical Regulation
        </label>
      </Box>
      {restrictions4.map((parentCategory, parentIndex) => (
        <React.Fragment key={parentIndex}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "#F9FAFC",
              height: "38px",
              border: "1px solid #E5E5E8",
              paddingX: "20px",
              paddingY: "10px",
            }}
          >
            <Box sx={{ width: "50%" }}>
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                {parentCategory.category}
              </label>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "25%",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                System
              </label>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "25%",
              }}
            >
              <label
                style={{
                  fontSize: "14px",
                }}
              >
                Human
              </label>
            </Box>
          </Box>
          {parentCategory.child.map((childCategory, childIndex) => (
            <Box
              key={childIndex}
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "white",
                height: "44px",
                border: "1px solid #E5E5E8",
                borderTop: "none",
                paddingX: "20px",
                paddingY: "10px",
              }}
            >
              <Box sx={{ width: "50%" }}>
                <label
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  {childCategory.category}
                </label>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25%",
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    disabled={childCategory.system.disabled}
                    control={
                      <Switch defaultChecked={childCategory.system.checked} />
                    }
                  />
                </FormGroup>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25%",
                }}
              >
                <FormGroup>
                  <FormControlLabel
                    disabled={childCategory.human.disabled}
                    control={
                      <Switch
                        checked={childCategory.human.checked}
                        onChange={(e) => {
                          const updatedData = [...restrictions4];
                          updatedData[parentIndex].child[
                            childIndex
                          ].human.checked = e.target.checked;
                          // console.log(updatedData, "updateData data");
                          setRestrictions4(updatedData);
                        }}
                      />
                    }
                  />
                </FormGroup>
              </Box>
            </Box>
          ))}
        </React.Fragment>
      ))}
      <Box
        className="mt-2"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={async () => {
            const updatedCustomIqs = {};
            restrictions4?.map((restriction) => {
              restriction?.child?.map((child) => {
                updatedCustomIqs[child.id] = {
                  customIqResponse: child.system.checked,
                  humanValidation: child.human.checked,
                };
              });
            });
            const updated = { ...customIqs, ...updatedCustomIqs };
            console.log(updated, updatedCustomIqs, "updated jhi");
            const docRef = doc(db, "items", itemData?.itemId);
            await updateDoc(docRef, {
              customiqRestrictions: updated,
            });
          }}
        >
          Submit
        </Button>
      </Box>
      {/* <Box sx={{ marginTop: "10px" }}>
        {data5.map((parentCategory, parentIndex) => (
          <React.Fragment key={parentIndex}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                backgroundColor: "#F9FAFC",
                height: "38px",
                border: "1px solid #E5E5E8",
                paddingX: "20px",
                paddingY: "10px",
              }}
            >
              <Box sx={{ width: "50%" }}>
                <label
                  style={{
                    fontSize: "14px",
                  }}
                >
                  {parentCategory.category}
                </label>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25%",
                }}
              >
                <label
                  style={{
                    fontSize: "14px",
                  }}
                >
                  System
                </label>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "25%",
                }}
              >
                <label
                  style={{
                    fontSize: "14px",
                  }}
                >
                  Human
                </label>
              </Box>
            </Box>
            {parentCategory.child.map((childCategory, childIndex) => (
              <Box
                key={childIndex}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "white",
                  height: "44px",
                  border: "1px solid #E5E5E8",
                  borderTop: "none",
                  paddingX: "20px",
                  paddingY: "10px",
                }}
              >
                <Box sx={{ width: "50%" }}>
                  <label
                    style={{
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    {childCategory.category}
                  </label>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "25%",
                  }}
                >
                  <FormGroup>
                    <FormControlLabel
                      disabled={childCategory.system.disabled}
                      control={
                        <Switch defaultChecked={childCategory.system.checked} />
                      }
                    />
                  </FormGroup>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "25%",
                  }}
                >
                  <FormGroup>
                    <FormControlLabel
                      disabled={childCategory.human.disabled}
                      control={
                        <Switch defaultChecked={childCategory.human.checked} />
                      }
                    />
                  </FormGroup>
                </Box>
              </Box>
            ))}
          </React.Fragment>
        ))}
      </Box> */}
    </>
  );
}

export default CommonRestrictionTable;
